module.exports = __webpack_public_path__ + "assets/img/fb8b406e1feeec33827f545e147e9b1c.png";